import { BLOCK_REASON_TYPE, CONTRACT_TYPE, PRODUCT_TYPE, SEARCH_BY } from '@shared/types/enums';

export type CollectionParam = {
  pageIndex: number;
  pageSize: number;
  sort?: {
    value: string;
    direction: 'asc' | 'desc';
  };
  filters?: {
    [value: string]: string;
  };
};

export type LoginParam = {
  email: string;
  password: string;
};

export type SearchParam = {
  country: string;
  value: string;
  by: string;
};

export type PocketVaultParam = {
  pageIndex: number;
  pageSize: number;
  type: string;
  status: string;
};

export type BlockReasonParam = {
  scope: string;
  contractType: CONTRACT_TYPE;
  productType: PRODUCT_TYPE;
  reasonType: BLOCK_REASON_TYPE;
}

export type BlockReasonTypeParam = {
  scope: string;
  accountCode: string;
  action: string;
}
